import { Phone } from "lucide-react";

const Navbar = () => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 px-6 md:px-16 py-4 bg-background border-b border-border">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <a href="#" className="font-heading text-2xl font-bold tracking-tight text-foreground">
          Urbanova
        </a>

        <div className="hidden md:flex items-center gap-8">
          {["Features", "Location", "Contact"].map((item) => (
            <a
              key={item}
              href={`#${item.toLowerCase()}`}
              className="font-body text-sm tracking-wide uppercase text-muted-foreground hover:text-foreground transition-colors"
            >
              {item}
            </a>
          ))}
        </div>

        <a
          href="tel:+38970803787"
          className="font-body text-sm font-medium text-foreground"
        >
          <Phone className="w-4 h-4 inline mr-2" />
          <span className="hidden sm:inline">+389 70 803 787</span>
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
